export default __webpack_public_path__ + "static/media/side-menu-arrow.b2cf8c57.svg";